export const PUT_ALARMS_SALES_START = 'OVID/PUT_ALARMS_SALES_START'
export const PUT_ALARMS_SALES_SUCCESS = 'OVID/PUT_ALARMS_SALES_SUCCESS'
export const PUT_ALARMS_SALES_FAILED = 'OVID/PUT_ALARMS_SALES_FAILED'
export const RESET_ALARMS_SALES = 'OVID/RESET_ALARMS_SALES'

export const ALARMS_CADENCE_ERROR_CODE = '0015'
